import styled from 'styled-components';

const Error = styled.div`
  color: ${(props) => props.theme.errorColor};
`;

export default Error;
